export default function Main({ children }: { children: React.ReactNode }) {
	return (
		<main className="flex-1 basis-3/4 border-l-border p-4 pb-20 md:border-l md:p-8">
			<>{children}</>
		</main>
	)
}
